import React, {useState} from 'react';
import Grid from "@material-ui/core/Grid";
import SimpleReactValidator from "simple-react-validator";
import {toast} from "react-toastify";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import {Link, useNavigate} from "react-router-dom";

import './style.scss';
import {red} from "@material-ui/core/colors";



const LoginPage = (props) => {
    document.title = "Acesso :: WC Portáteis - Luís Silvestre Unipessoal, Lda. | Urinóis, Lava Mãos, Contentores WC, Eventos, Obras, Agricultura";
    const push = useNavigate()

    const [value, setValue] = useState({
        nif: '',
        password: '',
        remember: false,
    });

    const changeHandler = (e) => {
        setValue({...value, [e.target.name]: e.target.value});
        validator.showMessages();
    };

    const rememberHandler = () => {
        setValue({...value, remember: !value.remember});
    };

    const [validator] = React.useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));



    const submitForm = (e) => {
        e.preventDefault();
        if (validator.allValid()) {
            setValue({
                nif: '',
                password: '',
                remember: false
            });
            validator.hideMessages();

            if (value.nif) {
                push('/home');
            }
        } else {
            validator.showMessages();
            toast.error('Preencha todos os campos');
        }
    };
    return (
        <Grid className="loginWrapper">
            <Grid className="loginForm">
                <h2>Área de Cliente</h2>
                <p>Aceda a toda a informação relativa aos seus contratos.</p>
                <h5>[TEMPORARIAMENTE INDISPONÍVEL]</h5><br />
                <form onSubmit={submitForm}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextField
                                className="inputOutline"
                                fullWidth
                                placeholder="NIF (Número de Identificação Fiscal)"
                                value={value.nif}
                                variant="outlined"
                                name="nif"
                                label="NIF"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)}
                            />
                            {validator.message('nif', value.nif, 'required')}
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                className="inputOutline"
                                fullWidth
                                placeholder="Password"
                                value={value.password}
                                variant="outlined"
                                name="password"
                                type="password"
                                label="Password / Código de Acesso"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)}
                            />
                            {validator.message('password', value.password, 'required')}
                        </Grid>
                        <Grid item xs={12}>
                            <Grid className="formAction">
                                <Link to="/forgot-password">Não sabe a sua password / código de acesso?</Link>
                            </Grid>
                            <Grid className="formFooter">
                                <Button fullWidth className="cBtnTheme" disabled="disabled">Aceder</Button>
                            </Grid>
                            <p className="noteHelp">Voltar ao<Link to="/">WC Portáteis</Link></p>
                        </Grid>
                    </Grid>
                </form>
                <div className="shape-img">
                    <i className="fi flaticon-honeycomb"></i>
                </div>
            </Grid>
        </Grid>
    )
};

export default LoginPage;